import { Shimmer, ShimmerElementType } from "@fluentui/react";

import { getInvoicePaymentDescription } from "./getInvoicePaymentDescription";
import { IActivationInstallment } from "./interfaces";
import { Scroll, Subtitle, Title } from "./styles";

import { PaymentMethodType } from "@/common/types/PaymentMethod.types";
import { transformToCurrencyString } from "@/utils/TransformToCurrencyString";

interface InvoiceSetupProps {
  setup: IActivationInstallment;
  title?: string;
  isLoading?: boolean;
  isTagService?: boolean;
  paymentMethodType?: PaymentMethodType;
}

export function InvoiceSetup({
  setup,
  title,
  isLoading = false,
  isTagService = false,
  paymentMethodType
}: InvoiceSetupProps) {
  if (isLoading) {
    return (
      <Scroll>
        {Array.from({ length: 3 }).map((_, index) => (
          <Shimmer
            key={index}
            style={{ marginBottom: "0.5rem" }}
            shimmerElements={[
              {
                type: ShimmerElementType.line,
                height: 30
              }
            ]}
          />
        ))}
      </Scroll>
    );
  }

  if (!setup) return null;

  const isInvoicePayment =
    paymentMethodType === PaymentMethodType.INVOICE_DEBIT;
  const invoicePaymentDescription = isInvoicePayment
    ? getInvoicePaymentDescription(setup)
    : "";

  return (
    <Scroll>
      {title && (
        <Title>
          <p>{title}</p>
        </Title>
      )}

      <Subtitle>
        <div>
          <p>Total da Adesão B</p>
          {invoicePaymentDescription && (
            <small className="description">{invoicePaymentDescription}</small>
          )}
        </div>
        <p>{transformToCurrencyString(setup.monthlyFee)}</p>
      </Subtitle>

      {!isTagService && (
        <Subtitle value={setup.sim}>
          <div>
            <p>Total da Ativação C</p>
            {isInvoicePayment && !setup.exemptSim && setup.sim > 0 && (
              <small className="description">
                Adicionado na primeira fatura
              </small>
            )}
          </div>
          <p className="value">{transformToCurrencyString(setup.sim)}</p>
        </Subtitle>
      )}

      {setup.combo > 0 && (
        <Subtitle>
          <p>Total do Combo</p>
          <p>{transformToCurrencyString(setup.combo)}</p>
        </Subtitle>
      )}

      {setup.others > 0 && (
        <Subtitle>
          <p>Valor do Frete</p>
          <p>{transformToCurrencyString(setup.others)}</p>
        </Subtitle>
      )}

      {setup.activation > 0 && (
        <Subtitle>
          <p>Valor de ativação</p>
          <p>{transformToCurrencyString(setup.activation)}</p>
        </Subtitle>
      )}

      {setup.memberShare > 0 && (
        <Subtitle>
          <p>Total da Cota Capital</p>
          <p className="value">
            {transformToCurrencyString(setup.memberShare)}
          </p>
        </Subtitle>
      )}

      {setup.discount > 0 && (
        <Subtitle value={0 - setup.discount}>
          <p>Desconto Personalizado</p>
          <p className="value">- {transformToCurrencyString(setup.discount)}</p>
        </Subtitle>
      )}

      <Subtitle>
        <strong>Total para Pagar</strong>
        <strong>{transformToCurrencyString(setup.total)}</strong>
      </Subtitle>
    </Scroll>
  );
}
